import axios from "axios"
export const getInstructivos = async () => {
    return axios.get('api/instructivos/ObtenerInstructivos')
}

